export const conferencesPlaylistOptions = [
  { label: 'All Videos', value: 'all-videos' },
  { label: 'Brainstorm AI', value: 'brainstorm-ai' },
  { label: 'Brainstorm Design', value: 'brainstorm-design' },
  { label: 'Brainstorm Finance', value: 'brainstorm-finance' },
  { label: 'Brainstorm Health', value: 'brainstorm-health' },
  { label: 'Brainstorm Tech', parent: 'brainstorm', value: 'brainstorm-tech' },
  { label: 'CEO Initiative', value: 'ceo-initiative' },
  { label: 'Fortune Global Forum', value: 'fortune-global-forum' },
  { label: 'Most Powerful Women/Next Gen', value: 'mpw' },
  { label: 'Fortune Conversations', value: 'fortune-conversations' },
  { label: 'Impact Initiative', value: 'impact-initiative' },
  { label: 'CFO Collaborative', value: 'cfo-collaborative' },
];
